<template>
  <div>
    <v-data-table
      :loading="loadingTable"
      :headers="headers"
      :items="ratePlans"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Tarifários</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            rounded
            class="mb-2"
            @click="openNew()"
          >
            <v-icon small>
              {{ icons.mdiPlus }}
            </v-icon>
            Novo Tarifário
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.period="{ item }">
        {{ formatPeriod(item) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap;">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click="editItem(item)"
              >
                {{ icons.mdiPencilOutline }}
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                v-bind="attrs"
                v-on="on"
                @click="deleteItem(item)"
              >
                {{ icons.mdiDeleteOutline }}
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <DialogRatePlan
      v-model="showDialog"
      :edited-item="editedItem"
      :categories="categories"
      @saved="onSaved"
    />

    <MsgDelete
      v-model="dialogDelete"
      @delete-yes="deleteItemConfirm()"
    />

    <v-expansion-panels
      v-if="totalLegacy > 0"
      v-model="legacyPanel"
      class="mt-4"
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            <v-icon
              small
              class="mr-1"
            >
              {{ icons.mdiHistory }}
            </v-icon>
            Tarifas Legadas
            <span class="ml-2 caption grey--text">({{ totalLegacy }} registros)</span>
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :loading="loadingLegacy"
            :headers="legacyHeaders"
            :items="legacyTariffs"
            class="elevation-0"
            :page-count="legacyNumberOfPages"
            :page="legacyCurrentPage"
            :server-items-length="totalLegacy"
            :options.sync="legacyOptions"
            :footer-props="{
              itemsPerPageText: 'Itens por pagina',
              itemsPerPageOptions: [5, 10, 15],
              showFirstLastPage: true,
            }"
          >
            <template v-slot:item.value="{ item }">
              {{ formatMoney(item.value) }}
            </template>

            <template v-slot:item.period="{ item }">
              {{ formatPeriod(item) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <div style="white-space: nowrap;">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      class="mr-2"
                      v-bind="attrs"
                      v-on="on"
                      @click="editLegacy(item)"
                    >
                      {{ icons.mdiPencilOutline }}
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="error"
                      v-bind="attrs"
                      v-on="on"
                      @click="deleteLegacyItem(item)"
                    >
                      {{ icons.mdiDeleteOutline }}
                    </v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:no-data>
              <NoDataTable></NoDataTable>
            </template>
            <template v-slot:loading>
              Carregando...
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <DialogTariff
      v-model="showLegacyDialog"
      :in_data="legacyEditedItem"
      :title="legacyFormTitle"
      @out_data="onLegacySaved"
    />

    <MsgDelete
      v-model="dialogLegacyDelete"
      @delete-yes="deleteLegacyConfirm()"
    />
  </div>
</template>

<script>
import {
  mdiDeleteOutline, mdiHistory, mdiPencilOutline, mdiPlus,
} from '@mdi/js'
import { mapActions } from 'vuex'
import MsgDelete from '@/components/MsgDelete.vue'
import NoDataTable from '@/components/NoDataTable.vue'
import DialogRatePlan from './_components/DialogRatePlan.vue'
import DialogTariff from '../Tariff/_components/DialogTariff.vue'

export default {
  components: {
    MsgDelete, NoDataTable, DialogRatePlan, DialogTariff,
  },

  data: () => ({
    loadingTable: false,
    showDialog: false,
    dialogDelete: false,
    ratePlans: [],
    categories: [],
    editedItem: null,
    editedIndex: -1,
    totalPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 1,
    options: {},

    totalLegacy: 0,
    legacyPanel: undefined,
    loadingLegacy: false,
    legacyTariffs: [],
    legacyEditedItem: {},
    legacyEditedIndex: -1,
    legacyNumberOfPages: 0,
    legacyCurrentPage: 0,
    legacyOptions: {},
    showLegacyDialog: false,
    dialogLegacyDelete: false,

    icons: {
      mdiPlus, mdiPencilOutline, mdiDeleteOutline, mdiHistory,
    },
    headers: [
      { text: 'DESCRIÇÃO', value: 'description' },
      { text: 'PERÍODO', value: 'period', sortable: false },
      {
        text: 'AÇÕES', value: 'actions', sortable: false, align: 'center',
      },
    ],
    legacyHeaders: [
      { text: 'ID', value: 'id' },
      { text: 'DESCRIÇÃO', value: 'description' },
      { text: 'TARIFA', value: 'value' },
      { text: 'PERÍODO', value: 'period', sortable: false },
      {
        text: 'AÇÕES', value: 'actions', sortable: false, align: 'center',
      },
    ],
  }),

  computed: {
    legacyFormTitle() {
      return this.legacyEditedIndex === -1 ? 'Nova Tarifa' : 'Editar Tarifa'
    },
  },

  watch: {
    options: {
      handler() {
        this.initialize()
      },
    },
    legacyPanel(val) {
      if (val === 0 && this.legacyTariffs.length === 0) {
        this.loadLegacy()
      }
    },
    legacyOptions: {
      handler() {
        if (this.legacyPanel === 0) this.loadLegacy()
      },
    },
  },

  created() {
    this.loadCategories()
    this.checkLegacyCount()
  },

  methods: {
    ...mapActions('rate_plan', {
      getAllRatePlans: 'getAll',
      storeRatePlan: 'store',
      updateRatePlan: 'update',
      deleteRatePlan: 'delete',
    }),
    ...mapActions('room_category', {
      getAllCategories: 'getAll',
    }),
    ...mapActions('tariff', {
      getLegacyAll: 'getAll',
      deleteLegacyTariff: 'delete',
    }),

    loadCategories() {
      this.getAllCategories({ itemsPerPage: 100, page: 1, search: '' }).then(res => {
        this.categories = res.data.data || res.data
      })
    },

    checkLegacyCount() {
      this.getLegacyAll({ itemsPerPage: 1, page: 1, search: '' }).then(res => {
        this.totalLegacy = res.data.total || 0
      })
    },

    initialize() {
      this.loadingTable = true
      const { page, itemsPerPage } = this.options
      this.getAllRatePlans({ itemsPerPage: itemsPerPage || 10, page: page || 1 })
        .then(res => {
          this.ratePlans = res.data.data
          this.totalPaginate = res.data.total
          this.numberOfPagesPaginate = res.data.last_page
          this.currentPagePaginate = res.data.current_page
        })
        .finally(() => { this.loadingTable = false })
    },

    openNew() {
      this.editedIndex = -1
      this.editedItem = null
      this.showDialog = true
    },

    editItem(item) {
      this.editedIndex = this.ratePlans.indexOf(item)
      this.editedItem = { ...item }
      this.showDialog = true
    },

    onSaved(ratePlan) {
      if (this.editedIndex === -1) {
        this.ratePlans.push(ratePlan)
        this.totalPaginate += 1
      } else {
        Object.assign(this.ratePlans[this.editedIndex], ratePlan)
      }
    },

    deleteItem(item) {
      this.editedItem = item
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      const index = this.ratePlans.indexOf(this.editedItem)
      this.deleteRatePlan(this.editedItem)
        .then(() => {
          this.ratePlans.splice(index, 1)
          this.totalPaginate -= 1
          this.dialogDelete = false
          this.$toast.success('Excluído com sucesso!')
        })
        .catch(() => {})
    },

    loadLegacy() {
      this.loadingLegacy = true
      const { page, itemsPerPage } = this.legacyOptions
      this.getLegacyAll({ itemsPerPage: itemsPerPage || 10, page: page || 1, search: '' })
        .then(res => {
          this.legacyTariffs = res.data.data
          this.totalLegacy = res.data.total
          this.legacyNumberOfPages = res.data.last_page
          this.legacyCurrentPage = res.data.current_page
        })
        .finally(() => { this.loadingLegacy = false })
    },

    editLegacy(item) {
      this.legacyEditedIndex = this.legacyTariffs.indexOf(item)
      this.legacyEditedItem = { ...item }
      this.showLegacyDialog = true
    },

    onLegacySaved(tariff) {
      if (this.legacyEditedIndex === -1) {
        this.legacyTariffs.push(tariff)
        this.totalLegacy += 1
      } else {
        Object.assign(this.legacyTariffs[this.legacyEditedIndex], tariff)
      }
    },

    deleteLegacyItem(item) {
      this.legacyEditedItem = item
      this.dialogLegacyDelete = true
    },

    deleteLegacyConfirm() {
      const index = this.legacyTariffs.indexOf(this.legacyEditedItem)
      this.deleteLegacyTariff(this.legacyEditedItem)
        .then(() => {
          this.legacyTariffs.splice(index, 1)
          this.totalLegacy -= 1
          this.dialogLegacyDelete = false
          this.$toast.success('Excluído com sucesso!')
        })
        .catch(() => {})
    },

    formatPeriod(item) {
      if (item.date_start || item.date_end) {
        const s = item.date_start ? this.formatDate(item.date_start) : ''
        const e = item.date_end ? this.formatDate(item.date_end) : ''

        return `${s} - ${e}`
      }

      return '—'
    },

    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)

      return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
    },

    formatMoney(value) {
      const v = parseFloat(value)
      if (!Number.isNaN(v)) {
        return v.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }

      return ''
    },
  },
}
</script>
